import { useMemo } from 'react';
import { t } from '../../../libraries/i18n';
import { TradeFair, TradeFairRegistration, TradeFairRegistrationAttendance } from '../index.types';
import './TradeFairAttendanceBlock.scss';

type Attendance = number | {
    value: number;
    max?: number;
    label?: string;
}

interface TradeFairAttendanceBlockProps {
    tradeFair?: TradeFair;
    registration?: TradeFairRegistration;
    attendance?: TradeFairRegistrationAttendance;
    hideMax?: boolean;
}

export const calculateAttendees = (type: keyof Omit<TradeFairRegistrationAttendance, 'timestamp'>, registrations?: TradeFairRegistrationAttendance[]) => {
    return registrations?.reduce((acc, reg) => acc + (reg[type] || 0), 0) || 0;
}

export const TradeFairAttendanceBlock = (props: TradeFairAttendanceBlockProps) => {
    const { tradeFair, registration, attendance, hideMax } = props;

    const attendances: Attendance[] = useMemo(() => {
        const _attendances = [{
            value: attendance?.attendeesAdult !== undefined ? attendance?.attendeesAdult : calculateAttendees('attendeesAdult', registration?.registrations),
            max: registration?.attendeesAdult,
            label: t('events.label_quantity')
        }];

        if (tradeFair?.attendeesChild1) {
            _attendances.push({
                value: attendance?.attendeesChild1 !== undefined ? attendance?.attendeesChild1 : calculateAttendees('attendeesChild1', registration?.registrations),
                max: registration?.attendeesChild1,
                label: t('events.label_quantity_1')
            });
        }

        if (tradeFair?.attendeesChild2) {
            _attendances.push({
                value: attendance?.attendeesChild2 !== undefined ? attendance?.attendeesChild2 : calculateAttendees('attendeesChild2', registration?.registrations),
                max: registration?.attendeesChild2,
                label: t('events.label_quantity_2')
            });
        }

        if (tradeFair?.attendeesChild3) {
            _attendances.push({
                value: attendance?.attendeesChild3 !== undefined ? attendance?.attendeesChild3 : calculateAttendees('attendeesChild3', registration?.registrations),
                max: registration?.attendeesChild3,
                label: t('events.label_quantity_3')
            });
        }

        return _attendances;
    }, [tradeFair, registration, attendance])

    return (
        <div className="TradeFairAttendanceBlock">
            {attendances.map((attendance, index) => (
                <div key={'attendance-' + index} className='attendance'>
                    <div className='attendance-count'>
                        {typeof attendance === 'number' ? !!attendance : attendance.value}
                        {!hideMax && typeof attendance !== 'number' && attendance.max !== undefined && <> / {attendance.max}</>}
                    </div>

                    {typeof attendance !== 'number' && attendance.label && <div className='attendance-label'>
                        {attendance.label}
                    </div>}
                </div>
            ))}
        </div>
    )
}
